module.exports = __webpack_public_path__ + "static/media/logo_asterisco.f2ca12bf.png";